import { createClient } from '@supabase/supabase-js';

// Configuration via variables d'environnement avec fallback
const getSupabaseConfig = () => {
  const envUrl = process.env['REACT_APP_SUPABASE_URL'];
  const envAnon = process.env['REACT_APP_SUPABASE_ANON_KEY'];
//  const defaultUrl = 'https://wagpdjkansavtejovjrq.supabase.co';
const defaultUrl = 'https://api.avenu.fr';
  const defaultAnon = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndhZ3BkamthbnNhdnRlam92anJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxMTg3MTcsImV4cCI6MjA2MzY5NDcxN30.UK5jVtvbsPcP2obwhe8Un4JGXlLB3N-VzaWDmeRLFKU';
  //const defaultAnon = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjMzMzU3ODM4Mjl9.7EFbGAzpW8C7Zzhdiw5UW3-txaiUQjb9tocmcpqIKA0';

  return {
    url: envUrl || defaultUrl,
    anonKey: envAnon || defaultAnon,
  };
};

const config = getSupabaseConfig();

export const supabase = createClient(config.url, config.anonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: localStorage,
    flowType: 'pkce',
  }
});

// Fonction utilitaire pour obtenir l'URL de redirection
// IMPORTANT: Toujours utiliser window.location.origin pour le web
export const getRedirectUrl = () => {
  // Pour le web, toujours utiliser l'origine actuelle
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/auth/callback`;
  }
  
  // Fallback (ne devrait jamais être utilisé dans le navigateur)
  return 'http://localhost:3000/auth/callback';
};

export default supabase;